export default __webpack_public_path__ + "static/media/MY_TRACKER_ICON_6.5a6360a7.svg";